import moment from "moment";

const noSystemMessageTypeId = 0;
const incidentSystemMessageTypeId = 2;
const dateFormat = "YYYY-MM-DD HH:mm";

// An incident is live from the moment it is raised and stays live until an end date closes it, so it
// starts now with no end date - the only dates any type can be given without the author saying so.
// Every date is held in UTC, so the incident start is stamped off the UTC clock, not the local one.
export function getDefaultSystemMessageDates(systemMessageTypeID) {
    if (systemMessageTypeID === incidentSystemMessageTypeId) {
        return {
            startDate: moment.utc().format(dateFormat),
            endDate: null
        };
    }

    return {
        startDate: null,
        endDate: null
    };
}

export const defaultSystemMessageModel = {
    systemMessageID: 0,
    ...getDefaultSystemMessageDates(noSystemMessageTypeId),
    systemMessageTypeID: noSystemMessageTypeId,
    message: "",
    url: "",
    active: true,
    statusPageID: "0"
};
